import { Collapse } from "antd";
import DatabaseIcon from "../../assets/icons/database.svg?react";
import type { QueryResultTable } from "./chat";
import type { FormattedSqlSources } from "@/utils/selectedSourcesFormatter";
import ExplanationCard from "./ExplanationCard";
import { distinctKeys } from "@/utils/distinctKeys";
import SqlResultTable from "./SqlResultTable";
import SqlProvenance from "@/components/Provenance/SqlProvenance";

const PANEL_STYLES = {
  header: {
    color: "#06709B",
    padding: "0px",
  },
};

export function SqlExplanation({
  explanation,
  query,
  resultTables,
}: {
  explanation: string | undefined;
  query: string | undefined;
  resultTables: QueryResultTable[];
}) {
  const tableKeys = distinctKeys(
    resultTables.map((table) => table.columns.join("\u241f")),
  );
  const resultPanel = resultTables.length
    ? [
        {
          key: "result",
          label: (
            <span className="text-[#06709B] font-medium">Query Results</span>
          ),
          children: (
            <div className="flex flex-col gap-3">
              {resultTables.map((table, index) => (
                <div key={tableKeys[index]} className="flex flex-col gap-1">
                  {resultTables.length > 1 && (
                    <span className="text-[11px] text-[#6F7F85]">
                      {index + 1}.
                    </span>
                  )}
                  <SqlResultTable table={table} />
                </div>
              ))}
            </div>
          ),
          styles: PANEL_STYLES,
        },
      ]
    : [];

  return (
    <div className="flex flex-col">
      <p className="text-[#556C75] whitespace-pre-wrap">
        {explanation && explanation.length > 0
          ? explanation
          : "No explanation available."}
      </p>
      <Collapse
        ghost
        bordered={false}
        defaultActiveKey={[]}
        items={[
          {
            key: "sql",
            label: (
              <span className="text-[#06709B] font-medium">SQL Queries</span>
            ),
            children: (
              <div className="overflow-x-auto bg-[#EFF1F2] py-[5px] px-3">
                {query && query.length > 0 ? (
                  <SqlProvenance query={query} />
                ) : (
                  <code className="whitespace-pre-wrap">
                    No SQL query available.
                  </code>
                )}
              </div>
            ),
            styles: PANEL_STYLES,
          },
          ...resultPanel,
        ]}
      />
    </div>
  );
}

export default function ChatSQLCard({
  sources,
  chatExplanation = true,
}: {
  sources: Partial<FormattedSqlSources>;
  chatExplanation?: boolean;
}) {
  const explanation = sources?.explanation;
  const query = sources?.sql_query;
  const resultTables = sources?.result_tables ?? [];

  return (
    <div data-testid="clinical-trial-database-agent-section">
      <ExplanationCard
        title="Clinical Trial Database Agent"
        Icon={DatabaseIcon}
        chatExplanation={chatExplanation}
      >
        <SqlExplanation
          explanation={explanation}
          query={query}
          resultTables={resultTables}
        />
      </ExplanationCard>
    </div>
  );
}
